import { MBonusStatus } from 'redux/services/mbonus/types'

export const MBONUS_STATUS_TEXT: Record<MBonusStatus, string> = {
  [MBonusStatus.in_process]: 'В очереди',
  [MBonusStatus.error]: 'На уточнении',
  [MBonusStatus.ready]: 'Подключено',
  [MBonusStatus.waiting]: 'В работе',
  [MBonusStatus.denied]: 'Отклонено',
}
